import { render, staticRenderFns } from "./NewVNetDetails.vue?vue&type=template&id=777dc453&scoped=true&"
import script from "./NewVNetDetails.vue?vue&type=script&lang=js&"
export * from "./NewVNetDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewVNetDetails.vue?vue&type=style&index=0&id=777dc453&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777dc453",
  null
  
)

export default component.exports